import * as stylex from "@stylexjs/stylex";
import { useState } from "react";
import HoverVideo from "@/components/launch/shell/HoverVideo";
import "@/design/tokens.stylex";
import { colors, radii, text } from "@/design/tokens.stylex";
/** The long side of every peek, so creatives of one format line up exactly. */
export const PEEK_SIZE = 420;

// Media snaps to the nearest advertising format, so two 9:16 videos open at
// the same size even when one is 1080×1920 and the other 720×1280.
const FORMAT_RATIOS = [1, 4 / 5, 9 / 16, 16 / 9, 1.91] as const;
export function peekBox(aspect: number | null): {
  width: number;
  height: number;
} {
  if (!aspect || !Number.isFinite(aspect) || aspect <= 0) return {
    width: PEEK_SIZE,
    height: PEEK_SIZE
  };
  const ratio = FORMAT_RATIOS.reduce((best, candidate) => Math.abs(Math.log(candidate / aspect)) < Math.abs(Math.log(best / aspect)) ? candidate : best);
  return ratio >= 1 ? {
    width: PEEK_SIZE,
    height: Math.round(PEEK_SIZE / ratio)
  } : {
    width: Math.round(PEEK_SIZE * ratio),
    height: PEEK_SIZE
  };
}

/**
 * The hover peek at one creative: its video when there is one, else its
 * poster, at the size of its format. Until the media reports its dimensions
 * the peek is square, then it settles on the format's box.
 */
export default function CreativePeek({
  videoUrl,
  posterUrl,
  fallback
}: {
  videoUrl: string | null;
  posterUrl: string | null;
  fallback: string;
}) {
  const [aspect, setAspect] = useState<number | null>(null);
  const box = peekBox(aspect);
  if (videoUrl) return <HoverVideo src={videoUrl} poster={posterUrl} width={box.width} height={box.height} onDimensions={(width, height) => setAspect(width / height)} />;
  if (posterUrl) return <img src={posterUrl} alt="" className="x1lliihq x1wpy2cq xlcwlql x19kjcj4" width={box.width} height={box.height} referrerPolicy="no-referrer" onLoad={event => setAspect(event.currentTarget.naturalWidth / event.currentTarget.naturalHeight)} />;
  return <span className="xrvj5dj x1ku5rj1 x1wpy2cq xlcwlql x1i6qc9y x1hqrb6m x1s688f x1dgsrnt xtvhhri" style={box}>
      {fallback}
    </span>;
}